import { createStyles, makeStyles } from '@material-ui/core';
import React from 'react';
import { useCommentState, useViewerState } from "../../index.js";
export const MARKER_SIZE = 10;
const useStyles = makeStyles(theme => createStyles({
  root: {
    position: 'absolute',
    top: _ref => {
      let {
        rotation,
        marker,
        zoomRatio
      } = _ref;

      switch (rotation) {
        case 90:
          return `${parseFloat(marker.x) * zoomRatio}px`;

        case 180:
          return 'unset';

        case 270:
          return 'unset';

        default:
          return `${parseFloat(marker.y) * zoomRatio}px`;
      }
    },
    right: _ref2 => {
      let {
        rotation,
        marker,
        zoomRatio
      } = _ref2;

      switch (rotation) {
        case 90:
          return `${parseFloat(marker.y) * zoomRatio}px`;

        case 180:
          return `${parseFloat(marker.x) * zoomRatio}px`;

        case 270:
          return 'unset';

        default:
          return 'unset';
      }
    },
    bottom: _ref3 => {
      let {
        rotation,
        marker,
        zoomRatio
      } = _ref3;

      switch (rotation) {
        case 90:
          return 'unset';

        case 180:
          return `${parseFloat(marker.y) * zoomRatio}px`;

        case 270:
          return `${parseFloat(marker.x) * zoomRatio}px`;

        default:
          return 'unset';
      }
    },
    left: _ref4 => {
      let {
        rotation,
        marker,
        zoomRatio
      } = _ref4;

      switch (rotation) {
        case 90:
          return 'unset';

        case 180:
          return 'unset';

        case 270:
          return `${parseFloat(marker.y) * zoomRatio}px`;

        default:
          return `${parseFloat(marker.x) * zoomRatio}px`;
      }
    },
    width: `${MARKER_SIZE}px`,
    height: `${MARKER_SIZE}px`,
    borderRadius: `${MARKER_SIZE}px`,
    backgroundColor: _ref5 => {
      let {
        isSelected
      } = _ref5;
      return isSelected ? theme.palette.primary.light : theme.palette.primary.dark;
    },
    cursor: 'pointer'
  }
}));
/**
 * Return a styled comment marker component
 * @param marker Attributes of the marker
 * @param zoomRatio Zoom ratio
 * @param isSelected Flag to store is marker is selected or not
 * @param rotation Page rotation degree
 * @returns styled comment marker component
 */

export function CommentMarker(_ref6) {
  let {
    marker,
    zoomRatio,
    isSelected,
    rotation
  } = _ref6;
  const classes = useStyles({
    marker,
    zoomRatio,
    isSelected,
    rotation
  });
  const viewerState = useViewerState();
  const commentState = useCommentState();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    onClick: ev => {
      ev.stopPropagation();
      ev.nativeEvent.stopImmediatePropagation();
      !viewerState.isPlacingCommentMarker && commentState.setActiveComment(marker.id);
    }
  });
}
//# sourceMappingURL=comment-marker.js.map